<template>
	<card class="ReCardKBPostEdit">
		<div class="bntGroup">
			<base-button @click="GoToEdit(false)" type="primary" class="no-border" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div>
		<h4 >Редактирование данных</h4>
		<hr>
		
		<ReFormPrinter 
			:masFormConfig="masAllFormParams" 
			:objSaveApiMethod="currentApiFormMethod"		
			:SuccessGo="SuccessGo"/>
	</card>
</template>

<script>
	import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';

	export default {
		name: 'ReCardKBPostEdit',
		components: {
			ReFormPrinter,
		},
		props: {
			kb_group:{
				type: String,
				default: 'KB_MAIN',
			}
		},
		data () {
			return {
				ver: 1,
				currentApiFormMethod: this.currentApiFormMethodComp(),
				masAllFormParams: this.currentFormConfig(),
				strMethod: '',	
				masTopicTags: [],				
			}
		},
		watch:{
			
		},
		computed: {
			
		},
		methods: {
			currentApiFormMethodComp(){
				let post_id = typeof this.$route.params.post_id == 'undefined'?'-1':this.$route.params.post_id;			
				return {apiMethod:'INSUPD',apiParam:{obj:this.$route.params.kb_group ,flt:{id:post_id},iData:[]}};
			},
			currentFormConfig(){
				let post_id = typeof this.$route.params.post_id == 'undefined'?'-1':this.$route.params.post_id;

				this.$GVO.ApiCall('GET_FORM',{obj:this.$route.params.kb_group,flt:{'id':post_id,}})
				.then((objApi) => {
					// console.log(objApi);
					if(objApi.success){
						//console.log(`${this.$route.params.kb_group}.GET_FORM`,this.$GVO.unlinkObject(objApi.config));
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
				return [];
				
			},
			
			SuccessGo(evt,dopParam){
				this.$router.push({path: '/data/knowledgebase'});
			},
			GoToEdit(bGoEdit=true){

			},
		},
		mounted() {

		},
	}
</script>
<style scoped>
	.ReCardKBPostEdit hr{
		color:#01B0E0; 
		background-color: #01B0E0; 
		height: 2px;
	}
	.ReCardKBPostEdit .bntGroup{
		position: absolute;
		z-index: 1;
		right: 15px;
		top: 5px;
	}

	.ReCardKBPostEdit >>> .ReCopyClipboard .btn.btn-icon:not(.btn-footer) .tim-icons{
		left: 45%;
		top: 47%;
	}

</style>
